/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as UpgradeGuestRouteImport } from './routes/upgrade-guest'
import { Route as UpgradeFailedRouteImport } from './routes/upgrade-failed'
import { Route as OpenAccountRouteImport } from './routes/open-account'
import { Route as SignedOutRouteImport } from './routes/_signedOut'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignedOutRegisterRouteImport } from './routes/_signedOut/register'
import { Route as SignedOutLoginRouteImport } from './routes/_signedOut/login'
import { Route as SignedOutForgotPasswordRouteImport } from './routes/_signedOut/forgot-password'
import { Route as AuthSuccessRouteImport } from './routes/_auth/success'
import { Route as AuthAuthorizeRouteImport } from './routes/_auth/authorize'
import { Route as AuthAccountRouteImport } from './routes/_auth/account'
import { Route as AuthEditNameRouteImport } from './routes/_auth/edit.name'
import { Route as AuthEditEmailRouteImport } from './routes/_auth/edit.email'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeGuestRoute = UpgradeGuestRouteImport.update({
  id: '/upgrade-guest',
  path: '/upgrade-guest',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeFailedRoute = UpgradeFailedRouteImport.update({
  id: '/upgrade-failed',
  path: '/upgrade-failed',
  getParentRoute: () => rootRouteImport,
} as any)
const OpenAccountRoute = OpenAccountRouteImport.update({
  id: '/open-account',
  path: '/open-account',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/_signedOut',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRegisterRoute = SignedOutRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => SignedOutRoute,
} as any)
const SignedOutLoginRoute = SignedOutLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => SignedOutRoute,
} as any)
const SignedOutForgotPasswordRoute = SignedOutForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => SignedOutRoute,
} as any)
const AuthSuccessRoute = AuthSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuthorizeRoute = AuthAuthorizeRouteImport.update({
  id: '/authorize',
  path: '/authorize',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAccountRoute = AuthAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEditNameRoute = AuthEditNameRouteImport.update({
  id: '/edit/name',
  path: '/edit/name',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEditEmailRoute = AuthEditEmailRouteImport.update({
  id: '/edit/email',
  path: '/edit/email',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/open-account': typeof OpenAccountRoute
  '/upgrade-failed': typeof UpgradeFailedRoute
  '/upgrade-guest': typeof UpgradeGuestRoute
  '/verify': typeof VerifyRoute
  '/account': typeof AuthAccountRoute
  '/authorize': typeof AuthAuthorizeRoute
  '/success': typeof AuthSuccessRoute
  '/forgot-password': typeof SignedOutForgotPasswordRoute
  '/login': typeof SignedOutLoginRoute
  '/register': typeof SignedOutRegisterRoute
  '/edit/email': typeof AuthEditEmailRoute
  '/edit/name': typeof AuthEditNameRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/open-account': typeof OpenAccountRoute
  '/upgrade-failed': typeof UpgradeFailedRoute
  '/upgrade-guest': typeof UpgradeGuestRoute
  '/verify': typeof VerifyRoute
  '/account': typeof AuthAccountRoute
  '/authorize': typeof AuthAuthorizeRoute
  '/success': typeof AuthSuccessRoute
  '/forgot-password': typeof SignedOutForgotPasswordRoute
  '/login': typeof SignedOutLoginRoute
  '/register': typeof SignedOutRegisterRoute
  '/edit/email': typeof AuthEditEmailRoute
  '/edit/name': typeof AuthEditNameRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_signedOut': typeof SignedOutRouteWithChildren
  '/open-account': typeof OpenAccountRoute
  '/upgrade-failed': typeof UpgradeFailedRoute
  '/upgrade-guest': typeof UpgradeGuestRoute
  '/verify': typeof VerifyRoute
  '/_auth/account': typeof AuthAccountRoute
  '/_auth/authorize': typeof AuthAuthorizeRoute
  '/_auth/success': typeof AuthSuccessRoute
  '/_signedOut/forgot-password': typeof SignedOutForgotPasswordRoute
  '/_signedOut/login': typeof SignedOutLoginRoute
  '/_signedOut/register': typeof SignedOutRegisterRoute
  '/_auth/edit/email': typeof AuthEditEmailRoute
  '/_auth/edit/name': typeof AuthEditNameRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/open-account'
    | '/upgrade-failed'
    | '/upgrade-guest'
    | '/verify'
    | '/account'
    | '/authorize'
    | '/success'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/edit/email'
    | '/edit/name'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/open-account'
    | '/upgrade-failed'
    | '/upgrade-guest'
    | '/verify'
    | '/account'
    | '/authorize'
    | '/success'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/edit/email'
    | '/edit/name'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_signedOut'
    | '/open-account'
    | '/upgrade-failed'
    | '/upgrade-guest'
    | '/verify'
    | '/_auth/account'
    | '/_auth/authorize'
    | '/_auth/success'
    | '/_signedOut/forgot-password'
    | '/_signedOut/login'
    | '/_signedOut/register'
    | '/_auth/edit/email'
    | '/_auth/edit/name'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  SignedOutRoute: typeof SignedOutRouteWithChildren
  OpenAccountRoute: typeof OpenAccountRoute
  UpgradeFailedRoute: typeof UpgradeFailedRoute
  UpgradeGuestRoute: typeof UpgradeGuestRoute
  VerifyRoute: typeof VerifyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade-guest': {
      id: '/upgrade-guest'
      path: '/upgrade-guest'
      fullPath: '/upgrade-guest'
      preLoaderRoute: typeof UpgradeGuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade-failed': {
      id: '/upgrade-failed'
      path: '/upgrade-failed'
      fullPath: '/upgrade-failed'
      preLoaderRoute: typeof UpgradeFailedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/open-account': {
      id: '/open-account'
      path: '/open-account'
      fullPath: '/open-account'
      preLoaderRoute: typeof OpenAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_signedOut': {
      id: '/_signedOut'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_signedOut/register': {
      id: '/_signedOut/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof SignedOutRegisterRouteImport
      parentRoute: typeof SignedOutRoute
    }
    '/_signedOut/login': {
      id: '/_signedOut/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof SignedOutLoginRouteImport
      parentRoute: typeof SignedOutRoute
    }
    '/_signedOut/forgot-password': {
      id: '/_signedOut/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof SignedOutForgotPasswordRouteImport
      parentRoute: typeof SignedOutRoute
    }
    '/_auth/success': {
      id: '/_auth/success'
      path: '/success'
      fullPath: '/success'
      preLoaderRoute: typeof AuthSuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/authorize': {
      id: '/_auth/authorize'
      path: '/authorize'
      fullPath: '/authorize'
      preLoaderRoute: typeof AuthAuthorizeRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/account': {
      id: '/_auth/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/edit/name': {
      id: '/_auth/edit/name'
      path: '/edit/name'
      fullPath: '/edit/name'
      preLoaderRoute: typeof AuthEditNameRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/edit/email': {
      id: '/_auth/edit/email'
      path: '/edit/email'
      fullPath: '/edit/email'
      preLoaderRoute: typeof AuthEditEmailRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAccountRoute: typeof AuthAccountRoute
  AuthAuthorizeRoute: typeof AuthAuthorizeRoute
  AuthSuccessRoute: typeof AuthSuccessRoute
  AuthEditEmailRoute: typeof AuthEditEmailRoute
  AuthEditNameRoute: typeof AuthEditNameRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccountRoute: AuthAccountRoute,
  AuthAuthorizeRoute: AuthAuthorizeRoute,
  AuthSuccessRoute: AuthSuccessRoute,
  AuthEditEmailRoute: AuthEditEmailRoute,
  AuthEditNameRoute: AuthEditNameRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface SignedOutRouteChildren {
  SignedOutForgotPasswordRoute: typeof SignedOutForgotPasswordRoute
  SignedOutLoginRoute: typeof SignedOutLoginRoute
  SignedOutRegisterRoute: typeof SignedOutRegisterRoute
}

const SignedOutRouteChildren: SignedOutRouteChildren = {
  SignedOutForgotPasswordRoute: SignedOutForgotPasswordRoute,
  SignedOutLoginRoute: SignedOutLoginRoute,
  SignedOutRegisterRoute: SignedOutRegisterRoute,
}

const SignedOutRouteWithChildren = SignedOutRoute._addFileChildren(
  SignedOutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  SignedOutRoute: SignedOutRouteWithChildren,
  OpenAccountRoute: OpenAccountRoute,
  UpgradeFailedRoute: UpgradeFailedRoute,
  UpgradeGuestRoute: UpgradeGuestRoute,
  VerifyRoute: VerifyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
